import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { fmtErr } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success(`Welcome back, ${u.name}`);
      if (u.role === "host") nav("/host");
      else if (u.role === "admin") nav("/admin");
      else nav("/browse");
    } catch (e) {
      toast.error(fmtErr(e));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] scent-wave grid md:grid-cols-2">
      <div className="hidden md:block relative">
        <img src="https://images.unsplash.com/photo-1587985064135-0366536eab42?w=1200" alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#0A1128]/40" />
        <div className="absolute bottom-10 left-10 right-10">
          <div className="text-[#D4AF37] text-xs tracking-[0.28em] uppercase font-semibold">Guest Smell™</div>
          <h1 className="mt-2 font-serif text-4xl text-white leading-tight">The freshness standard for stays.</h1>
        </div>
      </div>
      <div className="flex items-center justify-center p-8 md:p-16">
        <form onSubmit={submit} className="w-full max-w-md" data-testid="login-form">
          <h2 className="font-serif text-4xl text-[#0A1128] tracking-tight">Sign in</h2>
          <p className="mt-2 text-slate-500">Continue certifying, browsing, or reviewing.</p>

          <div className="mt-8 space-y-4">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" data-testid="login-email" value={email} onChange={(e)=>setEmail(e.target.value)} required className="mt-1" />
            </div>
            <div>
              <Label htmlFor="password">Password</Label>
              <Input id="password" type="password" data-testid="login-password" value={password} onChange={(e)=>setPassword(e.target.value)} required className="mt-1" />
            </div>
          </div>

          <Button type="submit" disabled={loading} data-testid="login-submit"
                  className="mt-8 w-full rounded-full bg-[#0A1128] hover:bg-[#1A2A3A] text-white h-11">
            {loading ? "Signing in…" : "Sign in"}
          </Button>

          <p className="mt-6 text-sm text-slate-500">
            New here? <Link to="/register" className="text-emerald-700 font-medium">Create an account</Link>
          </p>
          <div className="mt-6 p-4 rounded-lg border border-slate-200 bg-white/70 text-xs text-slate-500 space-y-1" data-testid="login-demo-hints">
            <div><b>Demo Host:</b> host@test.com / hostpass123</div>
            <div><b>Demo Guest:</b> guest@test.com / guestpass123</div>
            <div><b>Admin:</b> admin@guestsmell.com / admin123</div>
          </div>
        </form>
      </div>
    </div>
  );
}
